/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import getColor from "@insite/mobius/utilities/getColor";
import { primaryImageStyles } from "@monsma/Overrides/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { screen } from "@monsma/XDL/Helpers";
import SearchPlus from "@monsma/XDL/Icons/SearchPlus";
import { css } from "styled-components";

primaryImageStyles.primaryImage = {
    centeringWrapper: {
        css: css`
            &&& {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 230px !important;
                border: 1px solid ${getColor("common.ui12")};
                border-radius: 4px;
                overflow: hidden;
            }
        `,
    },
    img: {
        css: css`
            cursor: pointer;
            max-height: 100%;
            max-width: 100%;
        `,
    },
};

primaryImageStyles.fullPrimaryImageModal = {
    sizeVariant: "large",
};

primaryImageStyles.xngStyles = {
    fullPrimaryImageModalContentWrapper: {
        css: css`
            display: flex;
            width: 100%;

            ${screen("lt", "md")} {
                flex-direction: column;
            }
        `,
    },
    titleText: {
        variant: "h2",
        lineHeight: "34px",
        color: "secondary.main",
        css: css`
            margin-bottom: 22px;
        `,
    },
    titleStatisticsAndCarousel: {
        css: css`
            width: 25%;

            ${screen("lt", "md")} {
                width: 100%;
            }
        `,
    },
    primaryImageWrapper: {
        css: css`
            position: relative;
        `,
    },
    zoomIconWrapper: {
        css: css`
            position: absolute;
            bottom: 6px;
            right: 6px;
            background: ${getColor("common.black")};
            width: 30px;
            height: 30px;
            opacity: 75%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border-radius: 4px;

            @media print {
                display: none;
            }
        `,
    },
    zoomIcon: {
        src: SearchPlus,
        color: "common.background",
        size: 16,
    },
};

primaryImageStyles.fullPrimaryImage = {
    centeringWrapper: {
        css: css`
            min-height: 300px;
            width: 75%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-right: 30px;

            ${screen("lt", "md")} {
                width: 100%;
                padding-right: 0;
                margin-bottom: 30px;
            }
        `,
    },
    image: {
        css: css`
            img {
                width: 100%;
                height: 70vh;
                object-position: center;
                object-fit: contain;
            }
        `,
    },
};
